import { CLINIC_ROLES, UCH_CLINICS } from "static/constants";
import { getFacilityByAccountName } from "./account.util";

export const getCurrentUserRole = () => {
  const currentUserRole = localStorage.getItem("userRole");
  return currentUserRole;
};

export const checkIsCurrentUserOfClinic = () => {
  const role = getCurrentUserRole();
  return CLINIC_ROLES.includes(role);
};

/**
 * Decode JWT token payload.
 */
export const parseJWT = (token) => {
  try {
    const [, payload] = token.split(".");

    if (!payload) return null;

    const payloadBase64 = payload.replace(/-/g, "+").replace(/_/g, "/");

    const payloadJson = atob(payloadBase64);
    return JSON.parse(payloadJson);
  } catch {
    return null;
  }
};

export const getCurrentUserClinicName = () => {
  const currentUserClinicName = localStorage.getItem("clinicName");
  return currentUserClinicName;
};

export const getFollowingHospitalsList =
  localStorage
    .getItem("followingHospitals")
    ?.split(",")
    ?.map((item) => item.trim()) || [];

export const checkIsFollowingHospital = () => {
  const isFollowingHospital =
    localStorage.getItem("isFollowingHospital") === "true";
  return isFollowingHospital && getFollowingHospitalsList.length > 0;
};

export const checkIsCurrentUserFromUCH = (accounts) => {
  return accounts?.some((account) => {
    const accountNameMapper = {
      object: account?.name,
      string: account,
    };

    return UCH_CLINICS.includes(accountNameMapper[typeof account]);
  });
};

export const checkIsUCHClinicUser = (accounts) => {
  const currentUserClinic = localStorage.getItem("userRole");
  const isUCHUser = checkIsCurrentUserFromUCH(accounts);
  const isClinicUser = CLINIC_ROLES.includes(currentUserClinic);
  return isUCHUser && isClinicUser;
};

export const getClinicUserFacility = () => {
  if (!checkIsCurrentUserOfClinic()) return "";

  const currentUserClinic = localStorage.getItem("clinicName");
  return getFacilityByAccountName(currentUserClinic) || "";
};
